'use client';

import { ChevronDown } from 'lucide-react';

export default function Hero() {
  return (
    <section
      id="top"
      className="relative min-h-screen flex items-center justify-center overflow-hidden vignette-overlay"
    >
      {/* Background image with ken-burns zoom */}
      <div className="absolute inset-0">
        <img
          src="/images/hero.png"
          alt="Atelier de cuir MATAR — sac cognac sur piédestal de marbre noir"
          className="w-full h-full object-cover ken-burns"
          style={{ filter: 'brightness(0.55) saturate(1.1)' }}
        />
        {/* Color grade overlay */}
        <div
          className="absolute inset-0"
          style={{
            background:
              'linear-gradient(180deg, rgba(10,10,15,0.65) 0%, rgba(10,10,15,0.45) 40%, rgba(10,10,15,0.92) 100%)',
          }}
        />
        {/* Gold tint */}
        <div
          className="absolute inset-0 mix-blend-overlay opacity-30"
          style={{
            background:
              'radial-gradient(ellipse at 30% 60%, rgba(212,175,55,0.45) 0%, transparent 60%)',
          }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center pt-20 pb-24">
        {/* Eyebrow */}
        <div className="fade-up flex items-center justify-center gap-4 mb-7" style={{ animationDelay: '0.1s' }}>
          <span className="block h-px w-12 bg-gradient-to-r from-transparent to-[#D4AF37]" />
          <span className="eyebrow text-[#D4AF37]">
            Anvers · Belgique · Depuis 2014
          </span>
          <span className="block h-px w-12 bg-gradient-to-l from-transparent to-[#D4AF37]" />
        </div>

        {/* Brand name */}
        <h1
          className="fade-up font-display font-extrabold tracking-[0.06em] text-5xl sm:text-7xl lg:text-8xl mb-5 leading-[1.05]"
          style={{ animationDelay: '0.25s' }}
        >
          <span className="text-gold-gradient">MATAR</span>
          <br />
          <span className="text-[#F4E8C1] text-3xl sm:text-5xl lg:text-6xl font-light tracking-[0.3em]">
            STYLE CUIR
          </span>
        </h1>

        {/* Tagline */}
        <p
          className="fade-up font-serif italic text-xl sm:text-2xl lg:text-3xl text-[#F4E8C1]/90 max-w-3xl mx-auto leading-relaxed mb-3"
          style={{ animationDelay: '0.45s' }}
        >
          « L'Intelligence au service de l'Excellence. »
        </p>

        <p
          className="fade-up text-sm sm:text-base text-[#F4E8C1]/65 max-w-2xl mx-auto leading-relaxed font-light tracking-wide"
          style={{ animationDelay: '0.6s' }}
        >
          Maison de cuir de luxe. Chaque pièce façonnée à la main, héritage
          panafricain et savoir-faire belge. Une maison{' '}
          <span className="text-[#D4AF37] font-medium">SMARTEST CAPITAL</span>.
        </p>

        {/* CTAs */}
        <div
          className="fade-up flex flex-col sm:flex-row items-center justify-center gap-4 mt-10"
          style={{ animationDelay: '0.75s' }}
        >
          <a
            href="#collections"
            className="group relative inline-flex items-center justify-center px-9 py-4 bg-gold-gradient text-[#0a0a0f] font-semibold uppercase tracking-[0.18em] text-xs overflow-hidden transition-all duration-500 hover:glow-gold-strong"
          >
            <span className="relative z-10">Découvrir les Collections</span>
          </a>
          <a
            href="#atelier"
            className="inline-flex items-center justify-center px-9 py-4 border border-[#D4AF37]/45 text-[#F4E8C1] font-medium uppercase tracking-[0.18em] text-xs hover:bg-[#D4AF37]/10 hover:border-[#D4AF37] transition-all duration-500"
          >
            Visiter l'Atelier
          </a>
        </div>

        {/* Trust line */}
        <div
          className="fade-up mt-12 flex items-center justify-center gap-3 text-[10px] uppercase tracking-[0.3em] text-[#F4E8C1]/45"
          style={{ animationDelay: '0.9s' }}
        >
          <span>Cuir Pleine Fleur</span>
          <span className="text-[#D4AF37]">✦</span>
          <span>Fait Main</span>
          <span className="text-[#D4AF37]">✦</span>
          <span>Édition Limitée</span>
        </div>
      </div>

      {/* Scroll indicator */}
      <a
        href="#atelier"
        className="absolute bottom-7 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-[#D4AF37]/70 hover:text-[#D4AF37] transition-colors"
        aria-label="Descendre"
      >
        <span className="text-[10px] uppercase tracking-[0.3em]">Découvrir</span>
        <ChevronDown size={20} className="animate-bounce" />
      </a>
    </section>
  );
}
